<template>
  <v-row>
    <v-col cols="4" md="4">
      <v-card :elevation="1" class="fill-height">
        <v-card-item>
          <v-card-title class="text-left">category broads</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-plus" variant="text" @click="showNewBroadModal = true"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="broad in broads" :key="broad.id" @click="showBroadEditModal(broad)">
                    <td class="text-left">{{ broad.id }}</td>
                    <td class="text-left">{{ broad.name }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="4" md="4">
      <v-card :elevation="1" class="fill-height">
        <v-card-item>
          <v-card-title class="text-left">category types</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-plus" variant="text" @click="showNewTypeModal = true"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cat_type in types" :key="cat_type.id" @click="showTypeEditModal(cat_type)">
                    <td class="text-left">{{ cat_type.id }}</td>
                    <td class="text-left">{{ cat_type.name }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="4" md="4">
      <v-card :elevation="1" class="fill-height">
        <v-card-item>
          <v-card-title class="text-left">category countries</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-plus" variant="text" @click="showNewCountryModal = true"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="country in countries" :key="country.id" @click="showCountryEditModal(country)">
                    <td class="text-left">{{ country.id }}</td>
                    <td class="text-left">{{ country.name }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-item>
          <v-card-title class="text-left">category tags</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-plus" variant="text" @click="showNewTagModal = true"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th>id</th>
                    <th class="text-left">broad</th>
                    <th>name</th>
                    <th>hierarchy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tag in tags" :key="tag.id" @click="showTagEditModal(tag)">
                    <td class="text-left">{{ tag.id }}</td>
                    <td class="text-left">{{ tag.broad_name }}</td>
                    <td class="text-left"><v-chip size="small" class="ma-2">{{ tag.name }}</v-chip></td>
                    <td class="text-left"><v-chip size="small" class="ma-2">{{ tag.path }}</v-chip></td>
                  </tr>
                </tbody>
              </v-table>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- txn modals -->
  <CategoryBroadNewModal :show="showNewBroadModal" @close="showNewBroadModal = false"></CategoryBroadNewModal> <!-- add new record -->
  <CategoryBroadEditModal :show="showEditBroadModal" :currentRow="selectedRow" @close="showEditBroadModal = false"></CategoryBroadEditModal> <!-- edit a record -->
  <CategoryTypeNewModal :show="showNewTypeModal" @close="showNewTypeModal = false"></CategoryTypeNewModal> <!-- add new record -->
  <CategoryTypeEditModal :show="showEditTypeModal" :currentRow="selectedRow" @close="showEditTypeModal = false"></CategoryTypeEditModal> <!-- edit a record -->
  <CategoryCountryNewModal :show="showNewCountryModal" @close="showNewCountryModal = false"></CategoryCountryNewModal> <!-- add new record -->
  <CategoryCountryEditModal :show="showEditCountryModal" :currentRow="selectedRow" @close="showEditCountryModal = false"></CategoryCountryEditModal> <!-- edit a record -->
  <CategoryTagNewModal :show="showNewTagModal" :tags="tags" @close="showNewTagModal = false"></CategoryTagNewModal> <!-- add new record -->
  <CategoryTagEditModal :show="showEditTagModal" :tags="tags" :currentRow="selectedRow" @close="showEditTagModal = false"></CategoryTagEditModal> <!-- edit a record -->

</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import CategoryBroadNewModal from './modals/CategoryBroadNewModalPopup.vue';
import CategoryBroadEditModal from './modals/CategoryBroadEditModalPopup.vue';
import CategoryTypeNewModal from './modals/CategoryTypeNewModalPopup.vue';
import CategoryTypeEditModal from './modals/CategoryTypeEditModalPopup.vue';
import CategoryCountryNewModal from './modals/CategoryCountryNewModalPopup.vue';
import CategoryCountryEditModal from './modals/CategoryCountryEditModalPopup.vue';
import CategoryTagNewModal from './modals/CategoryTagNewModalPopup.vue';
import CategoryTagEditModal from './modals/CategoryTagEditModalPopup.vue';

export default {
  components: {
    CategoryBroadNewModal,
    CategoryBroadEditModal,
    CategoryTypeNewModal,
    CategoryTypeEditModal,
    CategoryCountryNewModal,
    CategoryCountryEditModal,
    CategoryTagNewModal,
    CategoryTagEditModal
  },
  data() {
    return {
      broads: [],
      types: [],
      countries: [],
      tags: [],
      showNewBroadModal: false,
      showEditBroadModal: false,
      showNewTypeModal: false,
      showEditTypeModal: false,
      showNewCountryModal: false,
      showEditCountryModal: false,
      showNewTagModal: false,
      showEditTagModal: false,
      selectedRow: {},
    };
  },
  async created() {
    this.getBroads();
    this.getTypes();
    this.getCountries();
    this.getTags();
  },
  computed: {
    ...mapState({
      token: "token"
    })
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async getBroads(){
      try {
      const response  = await axios.get("/securities/categorisations/config/broads",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.broads = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load broad categories' });
      }
    },
    async getTypes(){
      try {
      const response  = await axios.get("/securities/categorisations/config/types",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.types = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load security types' });
      }
    },
    async getCountries(){
      try {
      const response  = await axios.get("/securities/categorisations/config/countries",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.countries = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load countries' });
      }
    },
    async getTags(){
      try {
      const response  = await axios.get("/securities/categorisations/config/tags",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.tags = response.data;

      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load tags' });
      }
    },
    showBroadEditModal(row){
     this.selectedRow=row;
     this.showEditBroadModal = true;
    },
    showTypeEditModal(row){
     this.selectedRow=row;
     this.showEditTypeModal = true;
    },
    showCountryEditModal(row){
     this.selectedRow=row;
     this.showEditCountryModal = true;
    },
    showTagEditModal(row){
     this.selectedRow=row;
     this.showEditTagModal = true;
    },

  }
};

</script>


<style scoped>
.text-h4 {
  font-family: 'Courier New', Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

table{
  width: 100%;
}

table tr{
  cursor: pointer;
}

.fade-in-enter-active {
  transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-in-leave-active {
  transition: opacity 225ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.green_text{
  color: green;
}

.red_text{
  color: red;
}


</style>